import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard, ArrowRight } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const badges = [{
    icon: '📄',
    text: '100% PDF'
  }, {
    icon: '⚡',
    text: 'Acceso Inmediato'
  }, {
    icon: '🇦🇷',
    text: 'Material Argentino'
  }, {
    icon: '🔒',
    text: 'Pago Seguro'
  }];
  return <section className="relative bg-black text-white overflow-hidden pt-16 pb-20 lg:pt-24 lg:pb-28" data-id="element-150">
      {/* Background gradient blobs */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-151">
        <div className="absolute top-[10%] left-1/2 -translate-x-1/2 w-[120%] h-[80%] rounded-full bg-amber-600/20 blur-[120px]" data-id="element-152"></div>
        <div className="absolute -bottom-1/4 left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-yellow-500/10 blur-[100px]" data-id="element-153"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-154">
        <div className="max-w-4xl mx-auto text-center mt-[-50px]" data-id="element-155">
          {/* Brand mark */}
          <motion.div initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="inline-flex gap-2 text-amber-400 font-bold tracking-wide items-center justify-center mb-6" data-id="element-156">
            🏆 MASTERPACK APUESTAS MUNDIAL™
          </motion.div>

          {/* Massive headline */}
          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-2 text-balance text-[20px] mt-[-20px]" data-id="element-157">
            Todo lo que necesitás para apostar en el Mundial con criterio real.
          </motion.h1>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tight mb-10 text-amber-400 text-balance text-[18px]" data-id="element-158">
            Listo. Desde hoy.
          </motion.h2>

          {/* Hero Image — smaller per user request */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.3
        }} className="relative max-w-[200px] sm:max-w-[240px] md:max-w-[280px] mx-auto mb-10" data-id="element-159">
            <img src="https://cdn.magicpatterns.com/uploads/cwv7fG2T7GHfAneMQPuomy/MOCKUP_MUNDIAL.png" alt="Masterpack Apuestas Mundial - Sistema de análisis y estrategia para apostadores argentinos" className="w-full h-auto drop-shadow-[0_20px_50px_rgba(251,191,36,0.35)] mt-[-20px]" data-id="element-160" />
          </motion.div>

          {/* Tagline in accent color */}
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="md:text-xl font-bold text-amber-400 mb-6 text-balance text-[14px] mt-[-10px]" data-id="element-161">
            El sistema educativo N°1 de análisis y estrategia para apostadores
            del fútbol en Argentina
          </motion.p>

          {/* Badges */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex flex-wrap justify-center mb-[30px] gap-[6px]" data-id="element-162">
            {badges.map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-zinc-900/80 border border-amber-700/40 font-semibold backdrop-blur-sm text-[12px]" data-id="element-163">
                <span data-id="element-164">{badge.icon}</span> {badge.text}
              </span>)}
          </motion.div>

          {/* CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="mb-10" data-id="element-165">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center gap-2 px-10 py-5 rounded-2xl bg-amber-400 hover:bg-amber-500 text-black font-black uppercase tracking-wide shadow-[0_10px_40px_-10px_rgba(251,191,36,0.7)] hover:shadow-[0_15px_50px_-10px_rgba(251,191,36,0.9)] transition-all hover:-translate-y-1 md:text-base text-[12px]" data-id="element-166">
              🔥 QUIERO MI MASTERPACK AHORA
              <ArrowRight className="w-5 h-5" data-id="element-167" />
            </button>
          </motion.div>

          {/* Trust signals */}
          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.4
        }} className="flex flex-wrap justify-center items-center gap-x-6 gap-y-3 text-sm text-zinc-300 font-medium" data-id="element-168">
            <div className="flex items-center gap-1.5" data-id="element-169">
              <Shield className="w-4 h-4 text-emerald-400" data-id="element-170" />
              <span data-id="element-171">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-172">
              <Lock className="w-4 h-4 text-emerald-400" data-id="element-173" />
              <span data-id="element-174">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-175">
              <CreditCard className="w-4 h-4 text-amber-400" data-id="element-176" />
              <span data-id="element-177">Mercado Pago</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}